<template>
  <b-modal
    :id="id"
    size="lg"
    hide-header
    hide-footer
  >
    <div class="container px-4 pt-4">
      <!-- Header -->
      <div class="d-flex w-100 justify-content-center">
        <h3>{{ title | capitalize }}</h3>
      </div>
      <div class="d-flex w-100 justify-content-end">
        <b-link v-if="templateUrl" :href="templateUrl" class="text-info">
          {{ $t("download_template") | capitalize }}
        </b-link>
      </div>
      <Dropzone class="my-3" @cancel-upload="onCancel" :uploadUrl="uploadUrl" @success-upload="onSuccess" />
    </div>
    <!-- Header -->

  </b-modal>
</template>

<script>
import Dropzone from "./Dropzone"

export default {
  name: "UploadFileModal",
  components: {
    Dropzone,
  },
  methods: {
    onCancel () {
      this.$bvModal.hide(this.id)
    },
    onSuccess (uploadedFile) {
      this.$emit(this.id, uploadedFile)
      this.$bvModal.hide(this.id)
    }
  },
  props: {
    id: String,
    title: String,
    uploadUrl: String,
    templateUrl: String,
  },
}
</script>
